export function clamp(min, max, value) {
	return Math.max(min, Math.min(max, value));
}

export function lerp(start, end, t) {
	return start + (end - start) * t;
}